import { FaInfoCircle } from 'react-icons/fa';
import { Button } from '../../../../../../components/button/button';
import { Card } from '../../../../../../components/card/card';
import { IconButton } from '../../../../../../components/icon-button/icon-button';
import { LangTextArea } from '../../../../../../features/lang-textarea/lang-textarea';
import { Loader } from '../../../../../../components/loader/loader';
import { CompanyAddress } from './company-address/company-address';
import s from './company-base.module.css';
import { CompanySensitiveModal } from './company-sensitive-modal/company-sensitive-modal';
import { useCompanyBase } from './use-company-base';
import { Container } from '../../../../../../components/container/container';
import { Input } from '../../../../../../components/input/input';

export const CompanyBase = () => {
  const {
    disabled,
    toggleDisabled,
    isLoading,
    handleCancel,
    handleSave,
    t,
    companyProfile,
    handleUpdateCompanyProfile,
    name,
    handleCloseModal,
    handleOpenModal,
    isOpen,
  } = useCompanyBase();

  return (
    <Card className={s.feature}>
      {isLoading && <Loader />}
      <div className={s.controls}>
        {isOpen && <CompanySensitiveModal onClose={() => handleCloseModal()} />}
        <IconButton tooltip={t('Информация')} onClick={() => handleOpenModal()} variant="secondary">
          <FaInfoCircle />
        </IconButton>
        {!disabled && (
          <Button variant="secondary" onClick={handleSave}>
            {t('Сохранить')}
          </Button>
        )}
        <Button variant="secondary" onClick={disabled ? toggleDisabled : handleCancel}>
          {disabled ? t('Изменить') : t('Отменить')}
        </Button>
      </div>
      <Container label={t('Название компании')}>
        <Input
          disabled={disabled}
          value={name}
          onChange={(e) => handleUpdateCompanyProfile({ name: e.currentTarget.value })}
        />
      </Container>

      <Container label={t('Описание компании')}>
        <LangTextArea
          value={companyProfile?.description}
          disabled={disabled}
          onChange={(e) => handleUpdateCompanyProfile({ description: e })}
          showLanguageSelect
        />
      </Container>

      <CompanyAddress
        label={t('Фактический адрес')}
        className={s.part}
        disabled={disabled}
        type="actual_address"
      />
    </Card>
  );
};
